import React from "react";
function ListTable() {
  return (
    <div className="table-responsive table-instru">
      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th className="text-center">Process</th>
            <th className="text-center">Machine</th>
            <th className="text-center">Maker</th>
            <th className="text-center">Number of units</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-center" rowSpan={3}>
              Stamp
            </td>
            <td className="text-center">250 ton transfer stamp</td>
            <td className="text-center">Aida</td>
            <td className="text-center">2</td>
          </tr>
          <tr>
            <td className="text-center">150 ton stamp</td>
            <td className="text-center">Komatsu, Amada</td>
            <td className="text-center">10</td>
          </tr>
          <tr>
            <td className="text-center">110 ton stamp</td>
            <td className="text-center">Aida</td>
            <td className="text-center">5</td>
          </tr>

          <tr>
            <td className="text-center">
              Machining
            </td>
            <td className="text-center">Machining center</td>
            <td className="text-center">Brother, Jingdiao</td>
            <td className="text-center">65</td>
          </tr>
          

          <tr>
            <td className="text-center" rowSpan={8}>
              Second Process
            </td>
            <td className="text-center">Washing machine</td>
            <td className="text-center">-</td>
            <td className="text-center">2</td>
          </tr>
          <tr>
            <td className="text-center">Tumble barrel polish</td>
            <td className="text-center">-</td>
            <td className="text-center">8</td>
          </tr>
          <tr>
            <td className="text-center">Vibration barrel polish</td>
            <td className="text-center">-</td>
            <td className="text-center">2</td>
          </tr>
          <tr>
            <td className="text-center">Air blast machine</td>
            <td className="text-center">-</td>
            <td className="text-center">3</td>
          </tr>
          <tr>
            <td className="text-center">Laser marker</td>
            <td className="text-center">Keyence</td>
            <td className="text-center">5</td>
          </tr>
          <tr>
            <td className="text-center">Pad type printing machine</td>
            <td className="text-center">Navitas</td>
            <td className="text-center">7</td>
          </tr>
          <tr>
            <td className="text-center">Logo coloring machine</td>
            <td className="text-center">Musashi</td>
            <td className="text-center">3</td>
          </tr>
          <tr>
            <td className="text-center">Spot welder</td>
            <td className="text-center">Shindengen</td>
            <td className="text-center">1</td>
          </tr>

          <tr>
            <td className="text-center" rowSpan={2}>
              Anodizing
            </td>
            <td className="text-center">Trial line</td>
            <td className="text-center">-</td>
            <td className="text-center">1</td>
          </tr>
          <tr>
            <td className="text-center">M/P line (5 colors / line)</td>
            <td className="text-center">-</td>
            <td className="text-center">2</td>
          </tr>

          <tr>
            <td className="text-center" rowSpan={6}>
              Tooling fabrication, maintenance
            </td>
            <td className="text-center">Wire Electric Discharge</td>
            <td className="text-center">Mitsubishi</td>
            <td className="text-center">2</td>
          </tr>
          <tr>
            <td className="text-center">Fine pores electric discharge</td>
            <td className="text-center">Mitsubishi</td>
            <td className="text-center">1</td>
          </tr>
          <tr>
            <td className="text-center">Machining</td>
            <td className="text-center">Brother</td>
            <td className="text-center">1</td>
          </tr>
          <tr>
            <td className="text-center">Grinding</td>
            <td className="text-center">-</td>
            <td className="text-center">1</td>
          </tr>
          <tr>
            <td className="text-center">Milling</td>
            <td className="text-center">-</td>
            <td className="text-center">1</td>
          </tr>
          <tr>
            <td className="text-center">Lathe</td>
            <td className="text-center">-</td>
            <td className="text-center">1</td>
          </tr>

          <tr>
            <td className="text-center" rowSpan={6}>
              Inspection
            </td>
            <td className="text-center">CMM</td>
            <td className="text-center">Mitsutoyo, Hexagon</td>
            <td className="text-center">2</td>
          </tr>
          <tr>
            <td className="text-center">OMM</td>
            <td className="text-center">Mitsutoyo</td>
            <td className="text-center">3</td>
          </tr>
          <tr>
            <td className="text-center">Image Dimension</td>
            <td className="text-center">Keyence</td>
            <td className="text-center">1</td>
          </tr>
          <tr>
            <td className="text-center">3D scanner</td>
            <td className="text-center">Solutionix</td>
            <td className="text-center">1</td>
          </tr>
          <tr>
            <td className="text-center">Tensile strength</td>
            <td className="text-center">Comtex</td>
            <td className="text-center">1</td>
          </tr>
          <tr>
            <td className="text-center">
              Anodising color, thickness, roughness
            </td>
            <td className="text-center">-</td>
            <td className="text-center">1</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
export default ListTable;
